import {
  createConditionQueryObject,
  createQueryUrl,
} from 'components/SearchSideBar/logics/createSearchResultPageUrl';
import { DEFAULT_PARAMS } from 'components/SearchSideBar/constants';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { createUrl } from './createUrl';

/**
 * 遷移先URLの生成処理を実行し遷移する
 * @param selectedSearchCondition 選択した検索条件
 * @param oldestDayWdtno 一番古い保存した検索条件の番号
 * @param qcParam 資格id
 */
export const moveToSearchResultPage = (
  selectedSearchCondition: SelectedCurrentConditionType,
  oldestDayWdtno: number,
  qcParam: string | undefined
) => {
  // 検索条件のクエリ文字列を生成
  const searchConditionQuery = createQueryUrl(
    createConditionQueryObject({
      selectedCurrentCondition: selectedSearchCondition,
      qc: qcParam,
      oldestDayWdtno: oldestDayWdtno.toString(),
      leftPanelType: '1',
      defaultParams: DEFAULT_PARAMS,
    })
  );

  const url = createUrl(searchConditionQuery);

  window.location.href = url;
};
